import * as utils from "app/components/filters-bar/utils";
import type { IFilterHandlerReturnObj, IParams } from "app/routes/handlers/filter-consistency/filterConsistencyUtils";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";

export const getWebSourceIndustryRequiredChanges = (
    isSelectedDurationAllowed: boolean | undefined,
    selectedDuration: string,
    isSelectedCountryAllowed: boolean | undefined,
    selectedCountry: number,
    selectedWebSource: string,
    targetState: IRouterState,
    toParams: IParams,
): IFilterHandlerReturnObj => {
    // when we check for AvailableWebSource we need to send the selected CF & duration filter if they allowed,
    // because the list of the web source depend on the correct country & duration
    const selectedFiltersObj = {
        duration: isSelectedDurationAllowed ? selectedDuration : toParams.duration,
        country: isSelectedCountryAllowed ? selectedCountry : toParams.country,
        webSource: selectedWebSource,
        category: toParams.category,
    };

    const availableWebSourceObj = utils
        .getAvailableWebSource(targetState, selectedFiltersObj)
        ?.find((webSource: { id: string; available?: boolean; disabled?: boolean }) => webSource.id === selectedWebSource);
    const isSelectedWebSourceAllowed =
        availableWebSourceObj && availableWebSourceObj?.available && !availableWebSourceObj?.disabled;

    const displayChangeIndicator = !isSelectedWebSourceAllowed && !toParams.isWebSourceChanged;
    const isChanged = !isSelectedWebSourceAllowed;
    const shouldChangeToSelected = selectedWebSource !== toParams.webSource && isSelectedWebSourceAllowed;
    return {
        displayChangeIndicator,
        isChanged,
        shouldChangeToSelected,
    };
};
